
export default {
  state: {
    clients: [],
    running: [],
  },
  mutations: {
    SET_RUNNING_DATA: (state, payload) => {
      state.running = payload.running.data;
      state.clients = payload.clients.data.map(client => {
        return {
          text: client.Name,
          value: client.Name,
        };
      });
    }
  },
  actions: {
    getRunning: async ({ commit }, apphash) => {
      try {
        const running = await running.fetchRunning(apphash);
        const clients = await running.fetchClients();

        commit('SET_RUNNING_DATA', { running, clients });
        commit('SET_UCLIENTS', clients);
      } catch(err) {
        console.log(err);
      }
    }
  },
};
